import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPromotionsApi } from '../../redux/Reducers/commonApis';
import { TagIcon } from '@heroicons/react/24/outline';

export default function PromoCodeBanner({ onSelectCode }) {
  const { orderServiceAddress } = useSelector((s) => s.createNewOrder);
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderServiceAddress?.id) return;
    setLoading(true);
    getPromotionsApi(orderServiceAddress.id).then((res) => {
      setLoading(false);
      if (res?.status === 200 || res?.status === 201) {
        // Filter out expired promos
        const now = new Date();
        const active = (res?.data || []).filter((p) => {
          if (!p?.end_date) return true;
          return new Date(p.end_date) >= now;
        });
        setPromos(active);
      }
    });
  }, [orderServiceAddress?.id]);

  if (loading || promos.length === 0) return null;

  return (
    <div className='rounded-lg border border-green-200 bg-green-50/60 p-3'>
      <div className='mb-2 flex items-center gap-1.5'>
        <TagIcon className='h-4 w-4 text-green-600' />
        <p className='text-xs font-semibold text-green-700'>Available Promotions</p>
      </div>
      <div className='space-y-2'>
        {promos.map((p) => (
          <button
            key={p.id}
            type='button'
            className='flex w-full items-center gap-3 rounded-lg border border-green-200 bg-white px-3 py-2 text-left transition hover:border-green-400 hover:shadow-sm'
            onClick={() => onSelectCode(p.code)}
          >
            <div className='min-w-0 flex-1'>
              <div className='flex items-center gap-2'>
                <span className='rounded bg-green-100 px-1.5 py-0.5 text-xs font-bold text-green-700'>{p.code}</span>
                <span className='text-xs font-semibold text-green-600'>
                  {p.type === 'PERCENTAGE_OFF' ? `${p.type_amount}% OFF` : `$${p.type_amount} OFF`}
                </span>
              </div>
              {p.message && <p className='mt-0.5 truncate text-xs text-slate-500'>{p.message}</p>}
            </div>
            <span className='text-client-300 shrink-0 text-xs font-semibold'>Apply</span>
          </button>
        ))}
      </div>
    </div>
  );
}
